import { useState, useEffect } from 'react';

const EMAIL_PATTERN = /^([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,})(,\s*[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,})*$/;

const ServerSettingsTab = ({ emergencyContact, onSave, saving }) => {
    const [email, setEmail] = useState(emergencyContact || '');
    const [dirty, setDirty] = useState(false);
    const [valid, setValid] = useState(true);

    useEffect(() => {
        setEmail(emergencyContact || '');
        setDirty(false);
        setValid(true);
    }, [emergencyContact]);

    const handleChange = (e) => {
        const val = e.target.value;
        setEmail(val);
        setDirty(val !== (emergencyContact || ''));
        setValid(val === '' || EMAIL_PATTERN.test(val));
    };

    const handleSave = () => {
        if (!valid || !email.trim()) return;
        onSave({ emergency_contact: email.trim() });
    };

    return (
        <div>
            <div className="ss-warning">
                <i className="fe fe-alert-triangle" />
                Settings changed on this page require your local PalCare server to be rebooted to take effect.
            </div>

            <div className="pp-section">
                <div className="pp-section__header">
                    <h3 className="pp-section__title">Server Settings</h3>
                    {dirty && valid ? (
                        <div className="pp-section__actions">
                            <button className="dp-btn dp-btn--primary" disabled={saving} onClick={handleSave}>
                                {saving ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="pp-section__body">
                    <div className="ss-field" style={{ maxWidth: '420px' }}>
                        <label className="ss-field__label" htmlFor="ss-emerg-email">
                            System Offline Notification Email
                        </label>
                        <input
                            id="ss-emerg-email"
                            className={`ss-field__input${!valid ? ' is-invalid' : ''}`}
                            type="text"
                            value={email}
                            placeholder="email@example.com"
                            onChange={handleChange}
                        />
                        {!valid ? (
                            <p className="ss-field__error">
                                Provide a valid email address (comma-separated for multiple).
                            </p>
                        ) : (
                            <p className="ss-field__hint">
                                Comma-separated for multiple addresses.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServerSettingsTab;
